import "core-js/es6";
import "core-js/es7/reflect";
import "ts-helpers";
require("zone.js/dist/zone");

var devMode = require("devMode");

if (devMode) {
  Error.stackTraceLimit = Infinity;
  require("zone.js/dist/long-stack-trace-zone");
}



/** WEBPACK FOOTER **
 ** ./client/app/shared/utils/polyfills.ts
 **/